import React from 'react';
import logo from "./img/logo2.png";
import style from "./Header.module.css";

const Header = () => {
    let pathHome = '/react/profile';
    let pathFriends = '/react/friends';
    let pathDialogs = '/react/dialogs/user1';
    let pathVideos = '/react/videos';
    return (

    <header>
        <div className={style.header__container}>
            <div className={style.header__logo}>
                <img src={logo} alt="logo"/>
                <h2 className={style.logoName}>Friendo</h2>
            </div>
            <div className={style.header__nav}>
                <input className={style.input_header} type="text" placeholder="Search People, Pages, Groups etc"/>
                <span className={style.page_name}>Login</span>

                <div className={style.header__nav_icons}>
                        <a className={style.nav_item} href={pathHome}>
                            <i className="fa-solid fa-house"></i>
                        </a>
                        <a className={style.nav_item} href={pathFriends}>
                            <i className="fa-solid fa-user"></i>
                            <span className={style.badge}>9</span>
                        </a>
                        <a className={style.nav_item} href={pathVideos}>
                            <i className="fa-solid fa-bell"></i>
                            <span className={style.badge2}>5</span>
                        </a>
                        <a className={style.nav_item} href={pathDialogs}>
                            <i className="fa-solid fa-comment-dots"></i>
                            <span className={style.badge3}>7</span>
                        </a>
                </div>

            </div>
        </div>
    </header>
    );
};

export default Header;